// contactsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchAllContacts,
  fetchAssignedContacts,
} from "../../pages/setup/components/managementcompanies/services/managementContactService";

// Thunk to fetch all contacts
export const fetchAllContactsThunk = createAsyncThunk(
  "contacts/fetchAllContacts",
  async (_, thunkAPI) => {
    try {
      const data = await fetchAllContacts();
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Thunk to fetch contacts assigned to a management company
export const fetchAssignedContactsThunk = createAsyncThunk(
  "contacts/fetchAssignedContacts",
  async (managementId, thunkAPI) => {
    try {
      const data = await fetchAssignedContacts(managementId);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  assignedContacts: [],
  contactOptions: [],
  loading: false,
};

const contactsSlice = createSlice({
  name: "contacts",
  initialState,
  reducers: {
    setAssignedContacts: (state, action) => {
      state.assignedContacts = action.payload.map((contact) => ({
        ...contact,
        contactID: contact.contactId,
      }));
    },
    updateAssignedContact: (state, action) => {
      const { contactID, updates } = action.payload;
      state.assignedContacts = state.assignedContacts.map((contact) =>
        contact.contactID === contactID ? { ...contact, ...updates } : contact
      );
    },
    addAssignedContact: (state, action) => {
      state.assignedContacts.push(action.payload);
    },
    removeAssignedContact: (state, action) => {
      state.assignedContacts = state.assignedContacts.filter(
        (contact) => contact.contactID !== action.payload
      );
    },
    setContactOptions: (state, action) => {
      state.contactOptions = action.payload;
    },
    setContactsLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllContactsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllContactsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.contactOptions = action.payload;
      })
      .addCase(fetchAllContactsThunk.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching all contacts:", action.payload);
      })
      .addCase(fetchAssignedContactsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAssignedContactsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.assignedContacts = action.payload.map((contact) => ({
          ...contact,
          contactID: contact.contactId,
        }));
      })
      .addCase(fetchAssignedContactsThunk.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching assigned contacts:", action.payload);
      });
  },
});

export const {
  setAssignedContacts,
  updateAssignedContact,
  addAssignedContact,
  removeAssignedContact,
  setContactOptions,
  setContactsLoading,
} = contactsSlice.actions;

export const selectAssignedContacts = (state) =>
  state.contacts.assignedContacts;
export const selectContactOptions = (state) => state.contacts.contactOptions;
export const selectContactsLoading = (state) => state.contacts.loading;

export default contactsSlice.reducer;
